import { Component, OnInit } from '@angular/core';
import {
  FormControl,
  UntypedFormGroup,
} from '@angular/forms';
import {
  ButtonClassesEnum,
  IButtonModel,
  IconClassesEnum,
} from '@types-custom/models/ui/button-model';
import { GeoApiService } from '@shared/services/geo-api-service/geo-api.service';
import { GeoAPITypeEnum } from '@shared/models/geo-api-type.model';
import { Icon } from '@types-custom/models/ui/icon-model';
import { ParkingLineColorFilterEnum, ParkingStatusFilterEnum, ParkingTypeFilterEnum } from '@shared/models/parking-zone.model';
import { ParkingService } from '@shared/services/layer-service/parking-service/parking.service';
import { forkJoin, map, of } from 'rxjs';
import { MapLayers } from '@shared/utils/mappers/layers-map.model';
import { ParkingLinesEnum } from '@shared/models/parking-line.model';

@Component({
  selector: 'cdm-almeria-map-filter-parking-zone',
  templateUrl: './map-filter-parking-zone.component.html',
  styleUrls: ['./map-filter-parking-zone.component.scss'],
})
export class MapFilterParkingZoneComponent implements OnInit {

  readonly layer = MapLayers.ParkingZone;
  readonly DEFAULT_ZONES = [ParkingLinesEnum.GREEN_ZONE, ParkingLinesEnum.BLUE_ZONE];
  readonly DEFAULT_TYPES = [ParkingTypeFilterEnum.Via, ParkingTypeFilterEnum.Subterraneo];

  formGroup: UntypedFormGroup = new UntypedFormGroup({
    // zone: new UntypedFormGroup({
    zones: new FormControl(''),
    // }),
    // load_zone: new UntypedFormGroup({
    typeParking: new FormControl(''),
    status: new FormControl(''),
    // })
  });

  zoneList: { name: string, value: string }[] = [
    {
      name: 'Verde',
      value: ParkingLineColorFilterEnum.Verde
    },
    {
      name: 'Azul',
      value: ParkingLineColorFilterEnum.Azul
    }
  ];

  typeParkingList: { name: string, value: string }[] = [
    {
      name: ParkingTypeFilterEnum.Via,
      value: ParkingTypeFilterEnum.Via
    },
    {
      name: ParkingTypeFilterEnum.Subterraneo,
      value: ParkingTypeFilterEnum.Subterraneo
    }
  ];

  statusParkingList: { name: string, value: string }[] = [
    {
      name: 'Disponible',
      value: ParkingStatusFilterEnum.Disponible
    },
    {
      name: 'Ocupado',
      value: ParkingStatusFilterEnum.Ocupado
    },
    {
      name: 'Indefinido',
      value: ParkingStatusFilterEnum.Indefinido
    }
  ];

  Icon = Icon;
  buttonTag = 'APLICAR';
  buttonAttributes: IButtonModel = {};
  restorebuttonAttributes: IButtonModel = {};
  applybuttonAttributes: IButtonModel = {};
  // dropdownAttributes: IClassesAttributes = {};
  createButtonProps: IButtonModel = {
    label: 'APLICAR',
    classAttributes: {
      buttonClass: ButtonClassesEnum.primary_1_button,
      spanClass: IconClassesEnum.text_complementary_2,
    },
  };

  constructor(
    private geoApiService: GeoApiService,
    // private mapboxDataService: MapboxDataService,
    private parkingService: ParkingService
  ) { }
  ngOnInit() {
    this.generateButtonAttributes();
    this.parkingService.getFilter().subscribe((data) => {
      if (data?.source === this.layer) {
        const filter = data.filters ?? {};
        Object.keys(filter).forEach(k => {
          this.formGroup.get(k)?.patchValue(data.filters[k]);
        });
      }
    });
  }

  private generateButtonAttributes(): void {
    this.buttonAttributes = {
      label: this.buttonTag,
      postIcon: Icon.search_w,
      classAttributes: {
        buttonClass: ButtonClassesEnum.primary_1_button_filter,
      },
    };
    this.restorebuttonAttributes = {
      label: 'LIMPIAR',
      postIcon: undefined,
      classAttributes: {
        buttonClass: ButtonClassesEnum.filter_button,
        spanClass: 'text-weight-600 text-size-16 h-150 p-40-px mt-18'
      },
    };
    this.applybuttonAttributes = {
      label: 'BUSCAR',
      postIcon: undefined,
      classAttributes: {
        buttonClass: ButtonClassesEnum.primary_1_button_filter,
      },
    };
  }

  reloadData(response: any) {
    this.parkingService.linesFilterNotifier$.next(response);
    this.parkingService.setFilter(
      {
        source: this.layer,
        filters: this.formGroup.getRawValue()
      }
    );
    // validar si esta es la mejor opción
    document.querySelector<HTMLElement>('#Filtro').click();
    // para resaltar que se aplicó el filtro
    setTimeout(() => {
      document.querySelector<HTMLElement>('#Filtro').parentElement.classList.add('applied-filter');
      // Remover marker seleccionado
      // document.querySelector('.marker-active-situations-layer')?.classList.remove('marker-active-situations-layer');
    }, 10);
  }

  private getFormValues(groupName?: string) {
    const params = groupName
      ? this.formGroup.get(groupName).getRawValue()
      : this.formGroup.getRawValue();
    for (const key in params) {
      if (!params[key]) {
        delete params[key];
      }
    }
    params.zones = params.zones ? params.zones : this.DEFAULT_ZONES;
    return params;
  }

  private loadData(params: { [key: string]: any }) {
    let types = new Set();
    if (params.typeParking) {
      types = new Set(params.typeParking);
    }
    return forkJoin({
      dataLines: params.zones ? this.geoApiService.getParkingLineList(GeoAPITypeEnum.ParkingLine, true, { categories: params.zones }) : of([]),
      dataSpots: types.has(ParkingTypeFilterEnum.Via) ? this.geoApiService.getParkingSpotListFilter(GeoAPITypeEnum.ParkingSpot, true, params) : of([]),
      undergroundSpots: types.has(ParkingTypeFilterEnum.Subterraneo) ? this.geoApiService.getParkingSpotUnderground(GeoAPITypeEnum.ParkingUnderground) : of([]),
    }).pipe(map(
      resp => {
        const response = {
          baseLayer: this.layer,
          layers: [
            {
              layer: this.layer,
              data: resp.dataLines,
            },
            {
              layer: this.layer,
              data: resp.dataSpots,
            },
            {
              layer: this.layer,
              data: resp.undergroundSpots,
            },
          ]
        }
        return response;
      }
    ));
  }

  applyFilter() {
    const params = this.getFormValues();
    this.loadData(params).subscribe({
      next: (resp) => {
        this.reloadData(resp);
      },
    });
  }

  cleanFilter() {
    this.formGroup.reset();
    this.parkingService.setFilter(undefined);
    this.loadData({ zones: this.DEFAULT_ZONES, typeParking: this.DEFAULT_TYPES })
      .subscribe({
        next: (resp) => {
          this.reloadData(resp);
        },
      })
      document.querySelector<HTMLElement>('#Filtro').parentElement.classList.remove('applied-filter');
  }
}
